import { render, staticRenderFns } from "./AdminRecord.vue?vue&type=template&id=5dae1b8e&scoped=true"
import script from "./AdminRecord.vue?vue&type=script&lang=js"
export * from "./AdminRecord.vue?vue&type=script&lang=js"
import style0 from "./AdminRecord.vue?vue&type=style&index=0&id=5dae1b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae1b8e",
  null
  
)

export default component.exports